import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  DndContext,
  DragOverlay,
  closestCorners,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  MouseSensor
} from "@dnd-kit/core";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import Container from "./ContainerDnd";
import { Item } from "./SortableItem";
import RootContainer from "./RootContainerDnd";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { honeycombStructureDisplayState } from "../../globalStates/general/honeycombStructureDisplay";
import { sentenceState } from "../../globalStates/gameMain/sentence";
import CorrectPage from "../CompletePage/CorrectPage";
import Sentence from "../Sentence";
import MistakeWord from "./MistakeWord";
import { gameStatusState } from "../../globalStates/general/gameStatus";
import { countWords } from "../GameMain/fieldFunction";
import { useMedia } from "use-media";
const HoneycombSet = (props) => {
  const isPC = useMedia({ minWidth: '1000px' });
  const sentence = useRecoilValue(sentenceState);
  const setGameStatusValue = useSetRecoilState(gameStatusState);
  const [items, setItems] = useState({
    root: [],
    whoTop: [],
    whoBottom: [],
    doTop: [],
    doBottom: [],
    whatTop: [],
    whatBottom: [],
    howTop: [],
    howBottom: [],
    whereTop: [],
    whereBottom: [],
    whenTop: [],
    whenBottom: [],
    whyTop: [],
    whyBottom: [],
  });
  const itemIndexArr = [
    ["whoTop", "whoBottom"],
    ["doTop", "doBottom"],
    ["whatTop", "whatBottom"],
    ["howTop", "howBottom"],
    ["whereTop", "whereBottom"],
    ["whenTop", "whenBottom"],
    ["whyTop", "whyBottom"],
  ]

  const [judgeResulut, setJudgeResulut] = useState(); // 正解　→ true

  const [honeycombDisplay, setHoneycombDisplay] = useRecoilState(honeycombStructureDisplayState);

  const [mistakeWords, setMistakeWords] = useState([]);
  /** 配列内で値が重複してないか調べる 重複→ true**/
  function existsSameValue(a) {
    var s = new Set(a);
    return s.size != a.length;
  }

  const getWordIndex = (word) => {
    for (let i = 1; i < 8; i++) {
      if (sentence[i].word_top === word.word_top && sentence[i].word_bottom === word.word_bottom) {
        return i;
      }
    }
  }

  const isWordComplete = (words) => {
    if (words.length === 0 || words.length !== countWords(sentence, "isComplete")) return false;
    for (let i = 1; i < 8; i++) {
      if (sentence[i].word_top || sentence[i].word_bottom) {
        if (sentence[i].word_top && sentence[i].word_bottom) {
          let flag = [false, false];
          for (let j = 0; j < words.length; j++) {
            if (sentence[i].word_top === words[j]) {

              flag[0] = true;
            }
          }
          for (let j = 0; j < words.length; j++) {
            if (sentence[i].word_bottom === words[j]) {

              flag[1] = true;
            }
          }
          if (!flag[0] || !flag[1]) {

            return false;
          }
        } else {
          let flag = false;
          for (let j = 0; j < words.length; j++) {
            if (sentence[i].word_top === words[j] || sentence[i].word_bottom === words[j]) {

              flag = true;
            }
          }
          if (!flag) {

            return false;
          }
        }
      }
    }
    return true;
  }

  useEffect(() => {
    if (props.playerHasWords) {
      const tmp_Arr = items;
      tmp_Arr['root'] = [];
      props.playerHasWords.forEach((element, i) => {
        if (getWordIndex(element) > 3 || getWordIndex(element) === 2) {
          if (element.word_top) {
            tmp_Arr['root'] = tmp_Arr['root'].concat(element.word_top);
          }
          if (element.word_bottom) {
            tmp_Arr['root'] = tmp_Arr['root'].concat(element.word_bottom);
          }
        } else {
          tmp_Arr['root'] = tmp_Arr['root'].concat(element.contents);
        }

      });
      setItems(tmp_Arr);


      if (isWordComplete(tmp_Arr['root']) === true) {
        setGameStatusValue(5);
      }
    }
  }, [props.playerHasWords]);

  const [activeId, setActiveId] = useState();

  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    }),

  );


  function findContainer(id) {
    if (id in items) {
      return id;
    }

    return Object.keys(items).find((key) => items[key].includes(id));
  }

  function handleDragStart(event) {
    const { active } = event;
    const { id } = active;
    document.addEventListener('scroll', () => {
      // 単語を画面外にドラッグアンドドロップした時に起こるバグを改善
      window.scroll({
        top: 0,
        left: 0,
      });
    });

    setActiveId(id);
  }

  function handleDragOver(event) {
    const { active, over, draggingRect } = event;
    const { id } = active;
    const { id: overId } = over;
    // Find the containers
    const activeContainer = findContainer(id);
    const overContainer = findContainer(overId);

    if (
      !activeContainer ||
      !overContainer ||
      activeContainer === overContainer ||
      (overContainer !== 'root' && (items[overContainer].length >= 1))
    ) {
      return;
    }

    setItems((prev) => {
      const activeItems = prev[activeContainer];
      const overItems = prev[overContainer];

      // Find the indexes for the items
      const activeIndex = activeItems.indexOf(id);
      const overIndex = overItems.indexOf(overId);

      let newIndex;
      if (overId in prev) {
        // We're at the root droppable of a container
        newIndex = overItems.length + 1;
      } else {
        const isBelowLastItem =
          over &&
          overIndex === overItems.length - 1;

        const modifier = isBelowLastItem ? 1 : 0;

        newIndex = overIndex >= 0 ? overIndex + modifier : overItems.length + 1;
      }

      return {
        ...prev,
        [activeContainer]: [
          ...prev[activeContainer].filter((item) => item !== active.id)
        ],
        [overContainer]: [
          ...prev[overContainer].slice(0, newIndex),
          items[activeContainer][activeIndex],
          ...prev[overContainer].slice(newIndex, prev[overContainer].length)
        ]
      };
    });
  }

  function handleDragEnd(event) {

    const { active, over } = event;
    const { id } = active;
    const { id: overId } = over;

    const activeContainer = findContainer(id);
    const overContainer = findContainer(overId);

    if (
      !activeContainer ||
      !overContainer ||
      activeContainer !== overContainer
    ) {
      return;
    }

    const activeIndex = items[activeContainer].indexOf(active.id);
    const overIndex = items[overContainer].indexOf(overId);

    if (activeIndex !== overIndex) {
      setItems((items) => ({
        ...items,
        [overContainer]: arrayMove(items[overContainer], activeIndex, overIndex)
      }));
    }

    setActiveId(null);
  }

  /** 配列内で値が重複してないか調べる 重複→ true**/
  function existsSameValue(a) {
    for (let i = 0; i < a.length; i++) {
      for (let j = 0; j < a.length; j++) {
        if (i != j && a[i].contents === a[j].contents) {
          return true;
        }
      }
    }
    return false;
  }


  const judgeHoneycomb = async () => {
    let flag = false;
    let tmpArr = [];
    for (let correctI = 0; correctI < 7; correctI += 1) {
      if (items[itemIndexArr[correctI][0]][0]) {
        if (sentence[correctI + 1].word_top != items[itemIndexArr[correctI][0]][0]) {
          setJudgeResulut(false);
          flag = true;
          tmpArr.push(items[itemIndexArr[correctI][0]][0]);
        }
      }
      if (items[itemIndexArr[correctI][1]][0]) {
        if (sentence[correctI + 1].word_bottom != items[itemIndexArr[correctI][1]][0]) {
          setJudgeResulut(false);
          flag = true;
          tmpArr.push(items[itemIndexArr[correctI][1]][0]);
        }
      }


    }
    setMistakeWords(tmpArr);
    if (!flag && items['root'].length === 0) setJudgeResulut(true);
    else setJudgeResulut(false);
  }

  //style
  const honeycombStructure = css`
    overflow: hidden;
    display: ${honeycombDisplay};
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 150vh;
    -webkit-backdrop-filter: blur(5px);
    /* background-color: #ffffff84; */
    background-color: #ffffff;
    backdrop-filter: blur(6px);

    .honeycombArea {
      scale: ${isPC ? 1 : 0.5};

      margin-top: ${isPC ? "2vw" : "3vw"};
      margin-left: ${isPC ? "40vw" : "30vw"};
      width: 1px;
      height: 1px;
      user-select: none;
      position: relative;
    }

    .hxagon-top-label {
      color: #0026ff;
      font-size: 0.8em;

      position: absolute;
      white-space: nowrap;
      font-weight: bold;
      background-color: white;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
    }

    .hxagon-top-label-2 {
      color: #02b738;
      font-size: 0.8em;

      position: absolute;
      white-space: nowrap;
      font-weight: bold;
      background-color: white;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
    }

    .hxagon-top-label-3 {
      color: #000000;
      font-size: 0.8em;

      position: absolute;
      white-space: nowrap;
      font-weight: bold;
      background-color: white;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
    }

    .hxagon-top-content-blue {
      width: calc(196px - 50px);
      top: 26%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      font-size: 25px;
      color: #0026ff;
      z-index: 1;
    }

    .hxagon-bottom-content-blue {
      width: calc(196px - 50px);
      position: absolute;
      left: 50%;
      transform: translate(-50%, 50%);
      font-size: 25px;
      bottom: 26%;
      color: #0026ff;
      z-index: 1;
    }

    .hxagon-top-content-green {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: calc(196px - 50px);
      position: absolute;
      font-size: 25px;
      color: #02b738;
      z-index: 1;
    }

    .hxagon-bottom-content-green {
      width: calc(196px - 50px);
      position: absolute;
      left: 50%;
      transform: translate(-50%, 50%);
      font-size: 25px;
      bottom: 26%;
      color: #02b738;
      z-index: 1;
    }

    .hxagon-top-content-deep-red {
      position: absolute;
      width: calc(196px - 50px);
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 25px;
      top: 26%;
      color: #b12c52;
      z-index: 1;
    }

    .hxagon-bottom-content-red {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 50%);
      width: calc(196px - 50px);
      font-size: 25px;
      bottom: 26%;
      color: red;
      z-index: 1;
    }

    .hxagon-bottom-content-black {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 50%);
      width: calc(196px - 50px);
      font-size: 25px;
      bottom: 26%;
      color: #000000;
      z-index: 1;
    }

    .hxagon-top-content-black {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      width: calc(196px - 50px);
      font-size: 25px;
      top: 26%;
      color: #000000;
      z-index: 1;
    }
    .whyTop {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: calc(196px - 50px);
      position: absolute;
      font-size: 25px;
      color: #000000;
      z-index: 1;

    }



    .hxagon-follow-word-top {
      color: #0026ff;
      font-size: 0.8em;
      font-weight: bold;
      position: absolute;
      top: 32%;
      right: -27%;
      z-index: 1;
    }

    .hxagon-follow-word-bottom {
      color: #0026ff;
      font-size: 0.8em;

      font-weight: bold;
      line-height: 1.0em;
      position: absolute;
      bottom: 25%;
      right: -27%;
      z-index: 1;
    }

    .hxagon1-wrap {
      width: 196px;
      height: 228px;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon2-wrap {
      width: 196px;
      height: 228px;
      top: calc(228px / 2 + 228px / 4 - 2.26px);
      left: calc(196px / 2 - 0.4px);
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon3-wrap {
      width: 196px;
      height: 228px;
      top: calc(228px / 2 + 228px / 4 - 2.26px);
      left: calc(-1 * (196px / 2 - 0.52px));
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon4-wrap {
      width: 196px;
      height: 228px;
      top: calc(228px / 2 + 228px - (2.26px * 2));
      left: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon5-wrap {
      width: 196px;
      height: 228px;
      top: calc(228px / 2 + 228px - (2.26px * 2));
      left: calc(-1 * (196px - (0.52px * 2)));
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon6-wrap {
      width: 196px;
      height: 228px;
      top: calc(228px / 2 + 228px / 4 - 2.26px);
      left: calc(-1 * (196px / 2 - 0.52px) * 3);
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon7-wrap {
      width: 196px;
      height: 228px;
      top: 0px;
      left: calc(-1 * (196px - (0.52px * 2)));
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hexagon1Area {
      text-align: center;
      width: calc(75px * 1.5);
      /* 辺の長さを調整 */
      height: calc(130px * 1.5);
      /* 辺の長さを調整 */
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }

    .hexagon2Area {
      text-align: center;
      width: calc(75px * 1.5);
      /* 辺の長さを調整 */
      height: calc(130px * 1.5);
      /* 辺の長さを調整 */
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }



    .hexagon-1,
    .hexagon-2,
    .hexagon-3,
    .hexagon-4,
    .hexagon-5,
    .hexagon-6,
    .hexagon-7 {
      transform: rotate(90deg);
      width: calc(75px * 1.5);
      /* 辺の長さを調整 */
      height: calc(130px * 1.5);
      /* 辺の長さを調整 */
      position: relative;
    }

    .middle-line {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: inline-block;
      height: calc(130px * 1.5 - 3px);
      width: 0.001px;
      outline: 0.5px solid rgb(79, 79, 79);
      outline-style: dashed;
      z-index: 1;
    }

    .hexagon-1 div,
    .hexagon-2 div,
    .hexagon-3 div,
    .hexagon-4 div,
    .hexagon-5 div,
    .hexagon-6 div,
    .hexagon-7 div {
      width: calc(75px * 1.5);
      /* 辺の長さを調整 */
      height: calc(130px * 1.5);
      /* 辺の長さを調整 */
      position: absolute;
      /* 辺の長さを調整 */
      transform-origin: center;
      /* 初期値だけど必要な時用 */
      box-sizing: border-box;
    }

    .hexagon-1 div,
    .hexagon-7 div {
      /* 位置を調整 */
      border-top: 2px solid #0026ff;
      /* 辺の長さを調整 */
      border-bottom: 2px solid #0026ff;
      /* 調節しやすくなる */
      background-color: rgb(255, 255, 255);
    }

    .hexagon-2 div {
      /* 位置を調整 */
      border-top: 2px solid #02b738;
      /* 辺の長さを調整 */
      border-bottom: 2px solid #02b738;
      /* 調節しやすくなる */
      background-color: rgb(255, 255, 255);
    }

    .hexagon-3 div {
      /* 位置を調整 */
      border-top: 2px solid #ff0707;
      /* 辺の長さを調整 */
      border-bottom: 2px solid #ff0707;
      /* 調節しやすくなる */
      background-color: rgb(255, 255, 255);
    }

    .hexagon-4 div,
    .hexagon-5 div,
    .hexagon-6 div {
      /* 位置を調整 */
      border-top: 2px solid #000000;
      /* 辺の長さを調整 */
      border-bottom: 2px solid #000000;
      /* 調節しやすくなる */
      background-color: rgb(255, 255, 255);
    }

    .hexagon-1 div:nth-of-type(1),
    .hexagon-2 div:nth-of-type(1),
    .hexagon-3 div:nth-of-type(1),
    .hexagon-4 div:nth-of-type(1),
    .hexagon-5 div:nth-of-type(1),
    .hexagon-6 div:nth-of-type(1),
    .hexagon-7 div:nth-of-type(1) {
      transform: rotate(0deg);
    }

    .hexagon-1 div:nth-of-type(2),
    .hexagon-2 div:nth-of-type(2),
    .hexagon-3 div:nth-of-type(2),
    .hexagon-4 div:nth-of-type(2),
    .hexagon-5 div:nth-of-type(2),
    .hexagon-6 div:nth-of-type(2),
    .hexagon-7 div:nth-of-type(2) {
      transform: rotate(60deg);
    }

    .hexagon-1 div:nth-of-type(3),
    .hexagon-2 div:nth-of-type(3),
    .hexagon-3 div:nth-of-type(3),
    .hexagon-4 div:nth-of-type(3),
    .hexagon-5 div:nth-of-type(3),
    .hexagon-6 div:nth-of-type(3),
    .hexagon-7 div:nth-of-type(3) {
      transform: rotate(120deg);
    }

  `;

  const completeBtn = css`
    position: absolute;
    top: 88vh;
    right: 22vw;

    button {
      background:#555555;
      color:#fff;
      width: 10vw;
      height: 8vh;
      /*テキストの基点とするためrelativeを指定*/
      position: relative;
      /*ボタンの形状*/
      border: 1px solid #555;
      border-radius: 10px;
      padding: 20px;
      text-align: center;
      display: inline-block;
      text-decoration: none;
      outline: none;
      /*アニメーションの指定*/
      transition: all .2s;
      cursor: pointer;
      font-size: 1.1em;
    }


    /*hoverをしたらボックスに影がつく*/
    button:hover {
      background:white;
      color:#555555;
    }

    button span{
      /*絶対配置でテキストの位置を決める*/
      position: absolute;
      left: 50%;
      top:50%;
      transform:translate(-50%,-50%);
      /*アニメーションの指定*/
      transition: all .3s;
      /*ブロック要素にしてテキスト折り返しなし*/
      display: block;
      white-space: nowrap;
    }

    /*差し替わるテキストの設定*/
    button span:nth-of-type(2){
      opacity:0;/*透過0に*/
    }

    /*hoverするとテキストが入れ替わる設定*/
    button:hover span:nth-of-type(1){
      opacity:0;/*透過0に*/
    }

    button:hover span:nth-of-type(2){
      opacity:1;/*不透明に*/
    }

  `;


  return (
    <>

      {(items.root !== undefined && items.root !== null) ?
        <div className="honeycombArea-wrap" css={honeycombStructure}>
          <Sentence sentence={sentence} activeWord={activeId} />
          <CorrectPage judgeResulut={judgeResulut} />
          <MistakeWord judgeResulut={judgeResulut} mistakeWordsArr={mistakeWords} />
          <DndContext
            sensors={sensors}
            collisionDetection={closestCorners}
            onDragStart={handleDragStart}
            onDragOver={handleDragOver}
            onDragEnd={handleDragEnd}
          >
            <DragOverlay>{activeId ? <Item id={activeId} active={true} /> : null}</DragOverlay>
            <RootContainer id="root" items={items.root} activeId={activeId} />


            <div className='honeycombArea'>
              <div className='hxagon1-wrap'>
                <div className='hexagon1Area'>
                  <div className="hxagon-top-content-blue" id="whatTop">
                    <Container id="whatTop" items={items.whatTop} activeId={activeId} />
                  </div>
                  <div className="hxagon-bottom-content-blue" id="whatBottom">
                    <Container id="whatBottom" items={items.whatBottom} activeId={activeId} />
                  </div>
                  <div className="hxagon-top-label">what なに</div>
                  <div className="hxagon-follow-word-top">は</div>
                  <div className="hxagon-follow-word-bottom">に<br />を<br />〜</div>
                  <div className="hexagon-1">
                    <span className='middle-line'></span>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
              <div className='hxagon2-wrap'>
                <div className='hexagon2Area'>
                  <div className="hxagon-top-content-green" id="howTop">
                    <Container id="howTop" items={items.howTop} activeId={activeId} />
                  </div>

                  {/* <div className="hxagon-bottom-content-green" id="howBottom">
                    <Container id="howBottom" items={items.howBottom} activeId={activeId} />
                  </div> */}

                  <div className="hxagon-top-label-2">how どんな</div>
                  <div className="hexagon-2">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>

                </div>
              </div>
              <div className='hxagon3-wrap'>
                <div className='hexagon2Area'>
                  <div className="hxagon-top-content-deep-red" id="doTop">
                    <Container id="doTop" items={items.doTop} activeId={activeId} />
                  </div>
                  <div className="hxagon-bottom-content-red" id="doBottom">
                    <Container id="doBottom" items={items.doBottom} activeId={activeId} />
                  </div>
                  <div className="hexagon-3">
                    <span className='middle-line'></span>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>

                </div>
              </div>
              <div className='hxagon4-wrap'>
                <div className='hexagon2Area'>
                  <div className="hxagon-top-content-black">
                    <Container id="whereTop" items={items.whereTop} activeId={activeId} />
                  </div>
                  <div className="hxagon-bottom-content-black">
                    <Container id="whereBottom" items={items.whereBottom} activeId={activeId} />
                  </div>
                  <div className="hxagon-top-label-3">where どこ</div>
                  <div className="hexagon-4">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>

                </div>
              </div>
              <div className='hxagon5-wrap'>
                <div className='hexagon2Area'>
                  <div className="hxagon-top-content-black">
                    <Container id="whenTop" items={items.whenTop} activeId={activeId} />
                  </div>
                  <div className="hxagon-bottom-content-black">
                    <Container id="whenBottom" items={items.whenBottom} activeId={activeId} />
                  </div>
                  <div className="hxagon-top-label-3">when いつ</div>
                  <div className="hexagon-5">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>

                </div>
              </div>
              <div className='hxagon6-wrap'>
                <div className='hexagon2Area'>
                  <div className="whyTop">
                    <Container id="whyTop" items={items.whyTop} activeId={activeId} />
                  </div>

                  {/* <div className="hxagon-bottom-content-black">
                    <Container id="whyBottom" items={items.whyBottom} activeId={activeId} />
                  </div> */}

                  <div className="hxagon-top-label-3">why なぜ</div>
                  <div className="hexagon-6">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>

                </div>
              </div>
              <div className='hxagon7-wrap'>
                <div className='hexagon2Area'>
                  <div className="hxagon-top-content-blue">
                    <Container id="whoTop" items={items.whoTop} activeId={activeId} />
                  </div>
                  <div className="hxagon-bottom-content-blue">
                    <Container id="whoBottom" items={items.whoBottom} activeId={activeId} />
                  </div>
                  <div className="hxagon-top-label">who だれ</div>
                  <div className="hxagon-follow-word-top">は</div>
                  <div className="hxagon-follow-word-bottom">に<br />を<br />〜</div>
                  <div className="hexagon-7">
                    <span className='middle-line'></span>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>

          </DndContext>
          <div css={completeBtn}>
            <button onClick={() => { judgeHoneycomb() }}>

              {isPC ? <span>Complete</span> : <span>完成</span>}<span>完成</span>
            </button>
          </div>
        </div >
        : ""}

    </>
  );

};

export default HoneycombSet;
